/* global $, _, jQuery */

;(function($) {
    'use strict';

    $(document).on('ready Parsley::Init', function () {

        $('.form-parsley').each(function (index, element) {
            var $root = $(element);

            if ($root.data('validator')) {
                return false;
            }

            var parsleyForm = $root.parsley();
            var disabledOnInit = $root.data('disabled-on-init');
            var $buttons = $root.find('.form-parsley__button');

            var isInvisible = function (__id__) {
                return $('[data-parsley-id=' + __id__ + ']').is(':hidden');
            };
            var isRequired = function (element) {
                var attr = element.$element.attr('required');
                if (typeof attr !== typeof undefined && attr !== false) {
                    return true;
                }
            };
            var isFormValid = function () {
                return _.all(parsleyForm.fields, function (element) {
                    if (isInvisible(element.__id__)) {
                        return true;
                    } 
                    else if (isRequired(element)) {
                        return element.isValid() === true;
                    } 
                    else {
                        return true;
                    }
                });
            };

            var disableClass = $buttons.data('parsley-disable-class');
            var enableButtons = function () {
                $buttons
                .removeClass(disableClass)
                .next('.error').hide();
            };
            var disableButtons = function () {
                $buttons.addClass(disableClass);
            };

            if (disabledOnInit) {
                if (!isFormValid()) {
                    disableButtons();
                }
            }

            $root.off('submit.Parsley');

            parsleyForm.subscribe('parsley:field:success', function () {

                if (isFormValid()) {
                    enableButtons();
                    $.event.trigger({
                        type: 'Parsley::FormSuccess',
                        $form: $root,
                        formData: $root.serializeArray()
                    });
                } 
                else {
                    disableButtons();
                }
            });
            parsleyForm.subscribe('parsley:field:error', disableButtons);

            $root.on('submit', function () {
                $root.parsley().validate();
            });

            $root.on('Parsley::Reset', function () {
                parsleyForm.reset();
            });

            $root.data('validator', {
                isFormValid: isFormValid
            });
        });
    });
})(jQuery);